import React from "react";
import "./App.css";
import { Link, Redirect } from "react-router-dom";
import Axios from "axios";
import ReactTooltip from "react-tooltip";
import {
  IoIosLogOut,
  IoIosAlbums,
  IoMdCopy,
  IoIosInformationCircleOutline,
} from "react-icons/io";
import { FaFacebook, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import {
  BsPerson,
  BsLock,
  BsPen,
  BsTwitterX,
  BsTwitter,
  BsLinkedin,
  BsFacebook,
  BsX,
  BsWhatsapp,
  BsCopy,
} from "react-icons/bs";
import { FaHandshake } from "react-icons/fa";
// import Header from "./components/Header5";
import TopBarProgress from "react-topbar-progress-indicator";
import ClipLoader from "react-spinners/ClipLoader";
import { v4 as uuidv4 } from "uuid";
import { FacebookIcon, TwitterIcon } from "react-share";
import { SiX } from "react-icons/si";
import { CheckUserLogin } from "./sessions/CheckUserLoggin";
import MyRecruits from "./Wallet";
import { BiMenu } from "react-icons/bi";
import SideNavAff from "./layouts/SideNavAff";
import Header5 from "./components/Header5";
import Header from "./layouts/Header";
// import ScriptTag from "react-script-tag";

const uuid = uuidv4().replace("-", "").substr(1, 11);

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    const isMobile = window.innerWidth <= 768;
    this.state = {
      response: "",
      error: "",
      errorDisplay: "none",
      details: [],
      affiliateid: "",
      loadBarProgress: false,
      showSavebtn: true,
      showCliploader: false,
      confirmedCopy: false,
      placeholderText: true,
      affiliateCount: 0,
      isMobile,
      collapsed: isMobile,
    };
  }

  componentDidMount() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);

    const partnername = localStorage.getItem("partnername");
    const accounttype = localStorage.getItem("accounttype");
    const partnerid = localStorage.getItem("partnerid");
    document.title = partnername + " - Affiliate program";

    // window.location.reload();

    if (!localStorage.getItem("customid")) {
      localStorage.setItem("customid", partnerid + "" + uuid);
    }

    Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=RECRUITS&subquery=AFFILIATECOUNT&partnerid=" +
        partnerid,
      {
        withCredentials: true,
      }
    ).then((response) => {
      if (response.data.val == 1) {
        this.setState({
          affiliateCount: response.data.affiliateCount,
        });
      } else {
        this.setState({
          affiliateCount: 0,
        });
      }
    });

    Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=PARTNERDETAILS&partnerid=" +
        partnerid,
      {
        withCredentials: true,
      }
    ).then((response) => {
      this.setState({
        affiliateid: response.data.affiliateid ?? "",
      });
    });
  }

  save = () => {
    const partnerid = localStorage.getItem("partnerid");
    const affiliateid = localStorage.getItem("customid");

    this.setState({
      showCliploader: true,
      showSavebtn: false,
      loadBarProgress: true,
    });

    Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=SAVEAFFILIATEID&partnerid=" +
        partnerid +
        "&affiliateid=" +
        affiliateid,
      {
        withCredentials: true,
      }
    ).then((response) => {
      this.setState({
        affiliateid: response.data.affiliateid,
        showCliploader: false,
        showSavebtn: true,
        loadBarProgress: false,
      });
    });

    this.props.history.push({
      pathname: "/in",
    });
  };

  copyURL = () => {
    navigator.clipboard.writeText(
      "https://karamale.com?affiliateid=" + this.state.affiliateid
    );

    this.setState({ confirmedCopy: true, placeholderText: false });

    setTimeout(() => {
      this.setState({ confirmedCopy: false, placeholderText: true });
    }, 3500);
  };

  handleLogout = async () => {
    try {
      await fetch("https://karamale.com/apps/kscanner/logout.php", {
        method: "GET",
        credentials: "include", // sends cookies like sessionId
      });

      // Clear local data and redirect
      localStorage.clear();
      window.location.href = "/login";
      console.log("Loggedout");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768;
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }));
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }));
  };

  render() {
    if (localStorage.getItem("partnername") === null) {
      return <Redirect to="/login" />;
      //   return exit(1);
    } else {
    }

    const partnername = localStorage.getItem("partnername");
    const partnerid = localStorage.getItem("partnerid");
    const accounttype = localStorage.getItem("accounttype");

    const {
      loadBarProgress,
      showCliploader,
      showSavebtn,
      confirmedCopy,
      placeholderText,
    } = this.state;

    const text =
      "Organizing events? You need to check out #Karamale. Sell tickets, track revenue, and see real-time sales — all in one place.\n\nI'm part of their affiliate program because it works. See for yourself 👉";
    const url = "https://karamale.com?affiliateid=" + this.state.affiliateid;
    const shareUrl = `${encodeURIComponent(text)}&url=${encodeURIComponent(
      url
    )}`;

    const { collapsed, isMobile } = this.state;

    return (
      <div className="view">
        {loadBarProgress && <TopBarProgress />}
        <Header />
        {accounttype === "partner" ? (
          <>
            <SideNavAff
              collapsed={this.state.collapsed}
              onToggle={this.handleToggle}
            />
          </>
        ) : (
          <></>
          // <Header5 />
        )}
        <div
          className="main-content"
          style={{
            marginTop: 60,
            marginLeft: this.state.isMobile
              ? "0px"
              : this.state.collapsed
              ? "60px"
              : "240px",
          }}
        >
          {/* ✅ Mobile overlay when sidebar is open */}
          {isMobile && !collapsed && (
            <div
              className="mobile-overlay active"
              onClick={this.handleToggle}
            />
          )}

          {this.state.isMobile && this.state.collapsed && (
            <label className="mobile-toggle" onClick={this.handleToggle}>
              <BiMenu size={25} />
            </label>
          )}

          <MyRecruits />
        </div>

        {confirmedCopy && (
          <span className={"success-login text-center"}>Link copied!</span>
        )}
      </div>
    );
  }
}

export default Dashboard;
